import {
  IconBroadcast,
  IconCreditCard,
  IconDeviceTv,
  IconHelp,
} from "@tabler/icons-react";
import { NavbarRoute } from "../../Lib/Types";

export const routes: NavbarRoute[] = [
  { link: "services", label: "Services", icon: IconBroadcast },
  { link: "subscriptions", label: "My Subscriptions", icon: IconDeviceTv },
  { link: "transactions", label: "My Transactions", icon: IconCreditCard },
  { link: "support", label: "Support", icon: IconHelp },
];
